.label {
  font-family: Serif-Font, serif;
}
